import { BASE_URL } from './host'
// 请求异常 interceptor
export default (res, opts) => {
  // 自定义异常拦截器
  if (opts.interceptor && typeof opts.interceptor === 'function') {
    return opts.interceptor(res)
  }
  // 通用异常拦截器
  const { code, origin: { silent }} = res

  // 401 = 未登录/登录过期 410 = 其他地方登录  跳转登录页面
  if ((code === 401 || code === 410) && !silent) {
    return window && window.location.replace(BASE_URL.GY_PASSPORT + '?redirect=' + encodeURIComponent(window.location.href))
  }

  // 统一回调函数
  if (opts.callback && typeof opts.callback === 'function' && !silent) {
    return opts.callback(res)
  }

  // 最终返回异常
  return res
}
